import React, { useState } from "react";

import CompanyDetails from "./CompanyDetails";
import AssetSite from "./AssetSite";
import UserDetails from "./UserDetails";
import Close from "../../../../../../images/Close.svg";
import { Title } from "../../../../../../stories/Title/Title";
import useLabels from "../../../../../../customHooks/useLabels";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const View = ({ setModalFlag }: Props) => {
  const [companyDetails, setCompanyDetails] = useState(true);
  const [assetSite, setAssetSite] = useState(false);
  const [userDetails, setUserDetails] = useState(false);

  const handleTabClick = (
    tab: "companyDetails" | "assetSite" | "userDetails"
  ) => {
    setCompanyDetails(tab === "companyDetails");
    setAssetSite(tab === "assetSite");
    setUserDetails(tab === "userDetails");
  };
  const {companyLabel,itemLabel}=useLabels();
  return (
    <>
      <div className="subsidary__view">
        <div className="subsidary__view--title">
          <Title> View / Edit Details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="subsidary__view--tabs">
          <button
            onClick={() => handleTabClick("companyDetails")}
            className={companyDetails ? "active" : ""}
          >
            {companyLabel} Details
          </button>
          <button
            onClick={() => handleTabClick("assetSite")}
            className={assetSite ? "active" : ""}
          >
            {itemLabel} Site or Location Points
          </button>
          <button
            onClick={() => handleTabClick("userDetails")}
            className={userDetails ? "active" : ""}
          >
            User Details
          </button>
        </div>
        <div className="subsidary__view--form">
          {companyDetails && (
            <>
              <CompanyDetails setModalFlag={setModalFlag} />
            </>
          )}
          {assetSite && <AssetSite setModalFlag={setModalFlag} />}
          {userDetails && <UserDetails setModalFlag={setModalFlag}/>}
        </div>
      </div>
    </>
  );
};

export default View;
